import { Star } from "lucide-react";

import { cn } from "@/lib/utils";

interface StarRatingProps {
  value: number;
  max?: number;
  size?: number;
  className?: string;
  showValue?: boolean;
}

export function StarRating({ value, max = 5, size = 16, className, showValue }: StarRatingProps) {
  const rounded = Math.round(value * 2) / 2;
  return (
    <span className={cn("inline-flex items-center gap-0.5", className)} aria-label={`${value.toFixed(1)} out of ${max} stars`}>
      {Array.from({ length: max }, (_, i) => {
        const filled = i + 1 <= Math.floor(rounded);
        const half = !filled && i + 0.5 === rounded;
        return (
          <span key={i} className="relative inline-flex" style={{ width: size, height: size }}>
            <Star className="absolute inset-0 text-white/15" style={{ width: size, height: size }} />
            {(filled || half) && (
              <span className="absolute inset-0 overflow-hidden" style={{ width: half ? size / 2 : size }}>
                <Star className="fill-gold text-gold" style={{ width: size, height: size }} />
              </span>
            )}
          </span>
        );
      })}
      {showValue && <span className="ml-1.5 text-sm font-medium text-text-secondary">{value.toFixed(1)}</span>}
    </span>
  );
}
